import * as types from '../constants/actionTypes';

// Fetch audit logs with filters and pagination
export const fetchAuditLogs = (filters = {}) => ({
  type: types.FETCH_AUDIT_LOGS_REQUEST,
  payload: filters,
});

export const fetchAuditLogsSuccess = (data) => ({
  type: types.FETCH_AUDIT_LOGS_SUCCESS,
  payload: data,
});

export const fetchAuditLogsFailure = (error) => ({
  type: types.FETCH_AUDIT_LOGS_FAILURE,
  payload: error,
});

// Fetch single audit log by ID
export const fetchAuditLog = (id) => ({
  type: types.FETCH_AUDIT_LOG_REQUEST,
  payload: { id },
});

export const fetchAuditLogSuccess = (data) => ({
  type: types.FETCH_AUDIT_LOG_SUCCESS,
  payload: data,
});

export const fetchAuditLogFailure = (error) => ({
  type: types.FETCH_AUDIT_LOG_FAILURE,
  payload: error,
});

// Fetch audit summary
export const fetchAuditSummary = (filters = {}) => ({
  type: types.FETCH_AUDIT_SUMMARY_REQUEST,
  payload: filters,
});

export const fetchAuditSummarySuccess = (data) => ({
  type: types.FETCH_AUDIT_SUMMARY_SUCCESS,
  payload: data,
});

export const fetchAuditSummaryFailure = (error) => ({
  type: types.FETCH_AUDIT_SUMMARY_FAILURE,
  payload: error,
});


// Set filters
export const setAuditFilters = (filters) => ({
  type: types.SET_AUDIT_FILTERS,
  payload: filters,
});

// Clear filters
export const clearAuditFilters = () => ({
  type: types.CLEAR_AUDIT_FILTERS,
});

// Set pagination
export const setAuditPagination = (pagination) => ({
  type: types.SET_AUDIT_PAGINATION,
  payload: pagination,
});

// Note: Logging is handled automatically by the backend
// These functions are kept for compatibility but don't perform actual logging
export const logProductChange = (productId, changeType, oldData, newData) => {
  return async (dispatch) => {
    // Backend handles audit logging automatically
    // Just refresh the audit logs to show the new entries
    dispatch(fetchAuditLogs());
  };
};

export const logVendorChange = (vendorId, changeType, oldData, newData) => {
  return async (dispatch) => {
    // Backend handles audit logging automatically
    // Just refresh the audit logs to show the new entries
    dispatch(fetchAuditLogs());
  };
};
